export default "__VITE_ASSET__DkMkzkyF__"